import { openCallWidgetLink } from 'flow/actions/run-url-actions';
import Icon from 'flow/components/ui-components/Icon';
import { isURL } from 'flow/utils/call-widget-utils';
import { twMerge } from 'tailwind-merge';
import PropTypes from 'prop-types';
import React from 'react';

const GenericCallWidgetHeader = ({
    primaryLabel,
    actionLabel,
    actionUrl,
    actionIcon,
    actionCallback,
    darkMode,
    primaryIcon,
}) => {
    actionCallback = actionCallback || (() => {});
    const linkEnabled = isURL(actionUrl);
    const hasIconUrl = isURL(primaryIcon);

    return (
        <a
            className={twMerge(
                'flex items-baseline justify-between no-underline',
                linkEnabled && 'group/wg cursor-pointer',
            )}
            href={linkEnabled ? actionUrl : undefined}
            data-test-id={'cti-widget-header'}
            onClick={(event) => {
                event.preventDefault();
                actionCallback();
                if (actionUrl && linkEnabled) {
                    openCallWidgetLink(actionUrl);
                }
            }}
        >
            <div className="flex w-full items-center justify-between gap-x-2">
                <div className="flex w-auto max-w-3/4 min-w-1/4 justify-start">
                    <div
                        className={twMerge(
                            'flex max-w-4.5 justify-start',
                            darkMode ? '!fill-gray-600' : '!fill-gray-300',
                        )}
                    >
                        {hasIconUrl ? (
                            // Decorative: primaryLabel is beside it.
                            <img className="size-5" src={primaryIcon} alt="" />
                        ) : (
                            <Icon
                                iconKey="infoOutlinedIcon"
                                className={twMerge(
                                    'flex max-w-4.5 justify-start',
                                    darkMode
                                        ? '!fill-gray-300'
                                        : '!fill-gray-600',
                                )}
                            />
                        )}
                    </div>
                    <div
                        dir="auto"
                        className={twMerge(
                            'mx-3 w-auto flex-wrap content-stretch self-center overflow-hidden text-ellipsis whitespace-nowrap',
                            darkMode ? 'text-white' : 'text-black',
                        )}
                    >
                        {primaryLabel}
                    </div>
                </div>
                <div className="flex w-auto max-w-3/4 min-w-1/4 justify-end gap-x-2">
                    <div
                        dir="auto"
                        className={twMerge(
                            'me-3 w-auto flex-wrap content-stretch self-center overflow-hidden text-end text-sm text-ellipsis whitespace-nowrap group-hover/wg:font-bold',
                            darkMode ? 'text-gray-400' : 'text-gray-600',
                        )}
                    >
                        {actionLabel}
                    </div>
                    <div className="flex max-w-5 justify-end">
                        {actionIcon && (
                            <Icon
                                iconKey={actionIcon}
                                className={twMerge(
                                    darkMode
                                        ? 'text-gray-300'
                                        : 'text-gray-600',
                                )}
                            />
                        )}
                    </div>
                </div>
            </div>
        </a>
    );
};

GenericCallWidgetHeader.propTypes = {
    primaryLabel: PropTypes.string,
    actionLabel: PropTypes.string,
    actionUrl: PropTypes.string,
    actionIcon: PropTypes.node,
    actionCallback: PropTypes.func,
    darkMode: PropTypes.bool.isRequired,
    primaryIcon: PropTypes.string,
};

export default React.memo(GenericCallWidgetHeader);
